import { z } from 'zod';

export const intakeBudgetStepSchema = z.object({
  budget: z.number().min(1).or(z.null()).or(z.undefined()),
});

export type IntakeBudgetStepFormData = z.infer<typeof intakeBudgetStepSchema>;
